import { Dispatch, SetStateAction, useState } from "react";

import { PatentSearchFilterType } from "@/components/business/PatentContainer/patentList.types";
import SearchInput from "@atoms/SearchInput/SearchInput";
import { usePatentListFilterState } from "@stores/patentList";

import PatentSearchFilterSelect from "./components/PatentSearchFilterSelect/PatentSearchFilterSelect";
import {
  PATENT_LIST_INFO_FILTER,
  PATENT_LIST_PRESS_INFO_FILTER_KEY,
} from "./constants/pressInfoFilter.constants";
import * as S from "./PatentPressInfoSearch.style";

interface Props {
  currentPressFilter: PatentSearchFilterType;
  setCurrentFilter: Dispatch<SetStateAction<PatentSearchFilterType>>;
}

const PatentPressInfoSearch = ({
  currentPressFilter,
  setCurrentFilter,
}: Props) => {
  const [patentListFilter, setPatentListFilter] = usePatentListFilterState();
  const [typing, setTyping] = useState("");

  const { search } = patentListFilter;

  const handleSearchKeyboard = () => {
    const currentInput = typing.trim();

    const newSearch = { ...search };
    PATENT_LIST_PRESS_INFO_FILTER_KEY.forEach((key) => delete newSearch[key]);
    newSearch[currentPressFilter.key] = currentInput;

    if (currentInput) {
      setPatentListFilter({
        ...patentListFilter,
        search: newSearch,
        page: 1,
      });
    }
  };

  const handleSearchButton = () => {
    const currentInput = typing.trim();

    if (currentInput) {
      const newSearch = { ...search };
      PATENT_LIST_PRESS_INFO_FILTER_KEY.forEach((key) => delete newSearch[key]);
      newSearch[currentPressFilter.key] = currentInput;

      setPatentListFilter({
        ...patentListFilter,
        search: newSearch,
        page: 1,
      });
    }
  };

  return (
    <S.PressInfoSearchWrapper>
      <PatentSearchFilterSelect
        subTitle="Info Filter"
        filterList={PATENT_LIST_INFO_FILTER}
        currentFilter={currentPressFilter}
        setCurrentFilter={setCurrentFilter}
      />
      <SearchInput
        placeholder="Enter text for Patent search"
        onSearchButton={handleSearchButton}
        handleSearchKeyboard={handleSearchKeyboard}
        typing={typing}
        setTyping={setTyping}
        widthResize
      />
    </S.PressInfoSearchWrapper>
  );
};

export default PatentPressInfoSearch;
